// projectReducer.js

import { GET_MY_TASKS_FAILURE, GET_MY_TASKS_REQUEST, GET_MY_TASKS_SUCCESS } from "../Actions/Actions";




const initialState = {
  isLoading: false,
  myTasks: [],
  error: null,
};

const myTaskListReducer = (state = initialState,{type,payload}) => {
  switch (type) {
    case GET_MY_TASKS_REQUEST:
      return { ...state, isLoading: true, error: null  };
    case GET_MY_TASKS_SUCCESS:
      return { ...state, isLoading: false, myTasks: payload};
    case GET_MY_TASKS_FAILURE:
      return { ...state, isLoading: false, error: payload };
    default:
      return state;
  }
};

export default myTaskListReducer;
